import { annals } from '~features/annals/hooks';

import { SendComp } from './styles';

type TSendButton = {
	disabled: boolean;
	onSend: () => void;
};
export const SendButton = ({ disabled, onSend }: TSendButton) => {
	const annalsSendMsgButton = annals.chat.useSendMsgButton();

	const handleClick = () => {
		onSend();
		void annalsSendMsgButton();
	};

	return <SendComp onClick={handleClick} disabled={disabled} />;
};
